<script setup>
import { ref, onMounted } from "vue";
import axios from 'axios';
import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Toast from 'primevue/toast';
import { FilterMatchMode } from '@primevue/core/api';
import { useToast } from "primevue/usetoast";

const toast = useToast();

const comprobantes = ref();
let selectedFiles = ref([]);
const fileInput = ref(null);

const handleFiles = (event) => {
    selectedFiles.value = event.target.files;
    uploadFiles();
};

const filters = ref({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
});

async function getFiles() {
    try {
        let response = await axios.get('https://cuadrecaja.fenix-pos.com/api/get-files');
        
        comprobantes.value = response.data;

        comprobantes.value = response.data.map(item => ({
            ...item,
            fecha_formateada: new Date(item.created_at).toISOString().split('T')[0]
        }));
    } catch (error) {
        console.log(error);
    }
}

const uploadFiles = async () => {
    const formData = new FormData();
    for (let i = 0; i < selectedFiles.value.length; i++) {
        formData.append("zipPaths[]", selectedFiles.value[i]);
    }

    try {
        const response = await axios.post("https://cuadrecaja.fenix-pos.com/api/upload-files", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });

        if (response.status == 200) {
            toast.add({
                severity: "success",
                summary: "Archivos subidos",
                detail: "Los archivos se han subido correctamente.",
                life: 5000
            });

            getFiles();
        }

    } catch (error) {
        toast.add({
            severity: "error",
            summary: "ArchiHubo un problema",
            detail: "Hubo un problema al subir los archivos. Por favor, inténtelo de nuevo.",
            life: 5000
        });
    } finally {
        selectedFiles.value = [];
        if (fileInput.value) {
            fileInput.value.value = "";
        }
    }
};

const downloadExcel = (url) => {
  window.open(url, '_blank');
};

onMounted(() => {
  getFiles();
});
</script>

<template>
    <Toast />
    <div class="container-card">
        <div class="card">
            <div class="buttons-card">
                <div>
                    <IconField>
                        <InputIcon><i class="pi pi-search" /></InputIcon>
                        <InputText class="input" v-model="filters.global.value" type="text" autocomplete="off"
                            autocorrect="off" autocapitalize="off" spellcheck="false" placeholder="Buscar..." />
                    </IconField>
                </div>
                <div class="file-input-container">
                    <label for="fileInput" class="file-input-button"><i class="fa fa-upload icon"></i>Cargar
                        Facturas</label>
                    <input type="file" id="fileInput" name="zipPaths[]" multiple accept=".zip" @change="handleFiles"
                        ref="fileInput" />
                </div>
            </div>

            <div class="table">
                <DataTable 
                class="m-3" 
                :value="comprobantes" 
                :paginator="true" 
                :rows="6"
                :rowsPerPageOptions="[6, 10, 20, 50]" 
                :filters="filters"
                :globalFilterFields="['created_at', 'facturas_subidas']"
                stripedRows 
                resizableColumns 
                columnResizeMode="fit" 
                showGridlines 
                tableStyle="min-width: 50rem"
                >
                <Column field="fecha_formateada" header="Fecha" sortable style="min-width: 10rem"></Column>
                <Column header="Facturas">
                    <template #body="slotProps">
                        {{ slotProps.data.facturas_subidas.replace(/,/g, ', ') }}
                    </template>
                </Column>
                <Column header="Opciones" style="min-width: 7rem">
                    <template #body="slotProps">
                    <Button 
                        icon="pi pi-download" 
                        outlined 
                        rounded 
                        severity="success" 
                        @click="downloadExcel(slotProps.data.url)"
                        label="Descargar este archivo"
                    />
                    </template>
                </Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>


<style scoped>
.container-card {
    margin: 30px;
}

.card {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    width: 100%;
    height: 80dvh;
}

.buttons-card {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    padding-inline: 50px;
    padding-top: 20px;
}

.file-input-container {
    display: flex;
    flex-direction: row;
    gap: 10px;
}

.table {
    width: 100%;
    margin-top: 20px;
}

/* Ocultamos el input real */
input[type="file"] {
    display: none;
}

/* Botón estilizado */
.file-input-button {
    background-color: #11cdef;
    color: white;
    border-radius: 15px;
    padding: 12px 25px;
    cursor: pointer;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    display: inline-block;
    transition: background 0.3s ease;
}

.file-input-button:hover {
    background-color: #0bb6d6;
}

.icon {
    margin-right: 10px;
    color: white;
}
</style>
